
const orderStatusNav: Array<{ name: string; id: number | string }> = [
    {
        name: "全部订单",
        id: "",
    },
    {
        name: "待付款",
        id: 0,
    },
    {
        name: "待核销",
        id: 1,
    },
    {
        name: "已完成",
        id: 2,
    },
    {
        name: "售后",
        id: 3,
    },
];

const columnList: Array<any> = [
    {
        prop: "title",
        label: "尊享卡名称",
        width: 164,
    },
    {
        prop: "price",
        label: "售价",
        width: 80,
    },
    {
        prop: "store_name",
        label: "门店名称",
        width: 80,
    },
];

interface Person {
    name:string;
    age:number;
}

import { defineComponent, inject, ref, onMounted, reactive } from "vue";
import { getOrderTable } from "@/api/http";
import { validateInput } from "@/assets/js/formRules";
import { Request } from "@/api/request";

export default defineComponent({
    name: "packageManage",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["套餐推荐"]);
        const headClass = inject("headClass");
        let loading = ref(false),
            userinfo = ref(false),
            tableData = ref([] as Array<any>),
            screenParameter = reactive({
                store_id: -1,
                search:''
            }),
            selectList = reactive({
                storeList:[] as any
            }) ,
            currentPage = ref(1),
            pageSize = ref(10),
            total = ref(1);
        
        
        let getTableData = () => {
                loading.value = true;
                Request.axiosInstance({
                    url: 'adminapi/VipCard/platList',
                    data: {
                        page:currentPage.value,
                        pageSize:pageSize.value,
                        store_id:screenParameter.store_id,
                        search:screenParameter.search
                    }
                }).then((res: any) => {
                    tableData.value = res.content.list;
                    total.value = res.content.count;
                    loading.value = false;
                })
            },
            columnChange = (status: number,id: number) => {
                if(id){
                    Request.axiosInstance({
                        url: 'adminapi/VipCard/changeRecommend',
                        data: {
                            card_id: id,
                            status
                        }
                    }).then((res: any) => {
                    })
                }
            },
            selectChange = (()=>{
                currentPage.value = 1;
                getTableData();
            }),
            handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            };
        onMounted(async() => {
            getTableData();
            await Request.axiosInstance({
                url: 'adminapi/Framework/totalList'
            }).then((res: any) => {
                selectList.storeList = [{id:-1,store_name:"请选择"},...res?.content?.list];
            })
        });
        
        return {
            loading,
            tableData,
            headClass,
            getTableData,
            currentPage,
            pageSize,
            columnList,
            total,
            handleSizeChange,
            handleCurrentChange,
            screenParameter,
            selectList,
            columnChange,
            selectChange
        };
    },
});
